'use client';

import Script from 'next/script';
import { GA_MEASUREMENT_ID, isGaConfigured } from '@/lib/analytics';

/**
 * Renders nothing until NEXT_PUBLIC_GA_MEASUREMENT_ID is set to a real GA4 id (G-XXXXXXX).
 * Set it in your hosting provider's environment variables to enable analytics.
 */
export default function GoogleAnalytics() {
  if (!isGaConfigured) return null;

  return (
    <>
      <Script
        src={`https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`}
        strategy="afterInteractive"
      />
      <Script id="ga4-init" strategy="afterInteractive">
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', '${GA_MEASUREMENT_ID}');
        `}
      </Script>
    </>
  );
}
